import {routes} from "@/router"

export default {
  computed: {
    routes() {
      return {
        appointmentNeeded: {name: "appointment.needed"},
        appointmentNotNeeded: {name: "appointment.not-needed"},
        alreadyComplete: {name: "already.complete"},
        home: {name: "home"},
        step1: {name: "survey.step-1"},
        step2: {name: "survey.step-2"},
        step3: {name: "survey.step-3"},
        step4: {name: "survey.step-4"},
        terms: {name: "terms"},
      };
    },
  },

  methods: {
    getRoutePath(routeName) {
      for (let i in routes) {
        if (routes.hasOwnProperty(i)) {
          if (routes[i].name === routeName) {
            return routes[i].path;
          }
        }
      }

      return null;
    },
  }
}
